var chunkToChildrenMap = {
	"196": [
		574
	],
	"243": [
		121
	],
	"325": [
		530,
		862
	],
	"721": [
		530
	],
	"907": [
		297
	],
	"961": [
		939
	],
	"998": [
		295
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));